import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getUserListWithType } from "../../actions";
import Spinner from "../../components/Spinner";

const FishermanListScreen = () => {
  const dispatch = useDispatch();
  const { users } = useSelector((state) => state);
  useEffect(() => {
    document.title = "Poznaj rybaków";
    if (users.userListWithType.fisherman) return;
    dispatch(getUserListWithType("fisherman"));
  }, []);

  if (!users.userListWithType.fisherman) return <Spinner />;

  return (
    <div className="container main-container mb-3 mt-3">
      <div className="row mt-1">
        <div className="col-md-12">
          <table className="table table-striped">
            <tbody>
              {users.userListWithType.fisherman.map((fisherman, key) => (
                <tr key={key}>
                  <td>
                    <div className="row">
                      {fisherman.photo && (
                        <div className="col-md-3">
                          <img
                            className="img-fluid"
                            alt=""
                            src={fisherman.photo}
                          />
                        </div>
                      )}

                      <div className="col-md-9">
                        <p className="m-1">
                          {fisherman.firstName} {fisherman.lastName}
                        </p>
                        {fisherman.phone && fisherman.phone.length && (
                          <p className="m-1 text-muted">Numer telefonu: {fisherman.phone}</p>
                        )}
                        {fisherman.shipNo && (
                          <p className="m-1 small text-muted">
                            Kuter: {fisherman.shipNo}
                          </p>
                        )}
                      </div>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default FishermanListScreen;



// WEBPACK FOOTER //
// ./src/screens/MainPage/FishermanListScreen.js